import { render, staticRenderFns } from "./footWap.vue?vue&type=template&id=ff780dea&scoped=true&"
import script from "./footWap.vue?vue&type=script&lang=js&"
export * from "./footWap.vue?vue&type=script&lang=js&"
import style0 from "./footWap.vue?vue&type=style&index=0&id=ff780dea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff780dea",
  null
  
)

export default component.exports